<script>
import { getAndSyncQueryParams, updateQueryParams } from '@/utils/queryParams';
import { iSearchInput } from '@inscribe/signal';
import { InscribeEventsLogger, INSCRIBE_EVENTS } from '@/events-logger';

export default {
  components: {
    iSearchInput,
  },
  data() {
    return {
      params: getAndSyncQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
      }),
    };
  },
  computed: {
    value() {
      return decodeURIComponent(this.params.search || '');
    },
  },
  watch: {
    '$route.fullPath': {
      handler: function (newFullPath) {
        this.params = getAndSyncQueryParams({
          fullPath: newFullPath,
          router: this.$router,
          store: this.$store,
        });
      },
    },
  },
  beforeUnmount() {
    // Cleanup: Clear the debounce timer to avoid memory leaks
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
  },
  methods: {
    onInputChanged(value) {
      if (value === '') {
        value = undefined;
      }

      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          page: 1,
          search: value,
        },
      });
    },
    clearSearch() {
      updateQueryParams({
        fullPath: this.$route.fullPath,
        router: this.$router,
        store: this.$store,
        updates: {
          search: undefined,
        },
      });
    },
    onInputClicked() {
      InscribeEventsLogger.logEvent(INSCRIBE_EVENTS.DOCUMENTS_SEARCH_CLICKED, {
        itemName: 'document-search-input',
      });
    },
  },
};
</script>

<template>
  <div
    class="i-mb-lg i-radius-lg"
    data-dd-action-name="document-search-input"
    @click="onInputClicked"
  >
    <i-search-input
      id="documentSearchInput"
      data-testid="document-search-input"
      input-placeholder="Search document names"
      :debounce-time="400"
      :filled-value="value"
      @input="onInputChanged"
    ></i-search-input>
  </div>
</template>
